import React from "react";
import PropTypes from "prop-types";
import ScheduleSymbol from "./ScheduleSymbol";
import { shortLabelFor } from "./scheduleTokens";

/**
 * Compact pill for a drug schedule: the drug-marking logo from ScheduleSymbol
 * plus a short label. Used wherever schedules are listed (tables, summaries).
 */

// One colour per schedule for the whole inventory module. The schedule picker
// cards (InventoryConfig) read this map too, so cards and badges always match.
//   C 2 – C 5: red · OTC: green · Non Controlled: orange
export const SCHEDULE_COLORS = {
  "2": "danger",
  "3": "danger",
  "4": "danger",
  "5": "danger",
  "-999": "warning",
  otc: "success",
  prn: "primary"
};

// These marks already spell out their name, so no text sits beside them.
const SELF_LABELLED = new Set(["otc", "prn"]);

const ScheduleBadge = ({ token, label, title, size = 16, className = "" }) => {
  const key = String(token === undefined || token === null ? "" : token).toLowerCase();
  const color = SCHEDULE_COLORS[key] || "primary";
  const text = label || shortLabelFor(key);
  const showText = !SELF_LABELLED.has(key);
  const tooltip = title || text;

  return (
    <span
      className={`badge badge-subtle-${color} rounded-pill d-inline-flex align-items-center gap-1 fs-11 fw-semibold ${className}`}
      style={{ padding: showText ? "0.2rem 0.6rem 0.2rem 0.3rem" : "0.2rem 0.45rem" }}
      title={tooltip}
    >
      <ScheduleSymbol token={key} size={size} title={tooltip} wide />
      {showText && <span>{text}</span>}
    </span>
  );
};

ScheduleBadge.propTypes = {
  token: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};

export default ScheduleBadge;
